/* global */
import React from 'react'
import {Modal, Button} from 'react-bootstrap'

export default React.createClass({
  render: function () {
    return (
      <div>
        <Modal show={this.props.show} onHide={this.props.hide} dialogClassName='new-task-modal'>
          <Modal.Header closeButton>
            <div className='text-center' style={{marginTop: 25}}>
              <h2>{this.props.title}</h2>
              <p className='pull-down-xs-2'>{this.props.content}</p>
            </div>
            <Button onClick={this.props.hide} className='pull-down-xs-2' bsClass='btn btn-success btn-sm center-block' bsStyle='primary'>Close</Button>

          </Modal.Header>
        </Modal>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/modals/notification-modal.jsx